import React from 'react';
import '../App.css';
import Main from './Main';
import firebase from "firebase/app";
import {ADMIN_MAP} from '../helpers/Util';

// TODO: Remove this hack once Maria's able to access admin tool normally.
let firebaseDBInternal = firebase.database.INTERNAL;
firebaseDBInternal.forceLongPolling();

let _ = require('lodash');
let config = {
  apiKey: process.env.REACT_APP_FIREBASE_WEB_API_KEY,
  authDomain: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}.firebaseapp.com`,
  databaseURL: `https://${process.env.REACT_APP_FIREBASE_RTDB_ID}.firebaseio.com`,
};
var firebaseApp;
if (!firebase.apps.length) {
  firebaseApp = firebase.initializeApp(config);
} else {
  firebaseApp = firebase.apps[0];
}
let ADMINS = Object.keys(ADMIN_MAP);

export default class Signin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    }

    this.emailChange = this.emailChange.bind(this);
    this.passwordChange = this.passwordChange.bind(this);
    this.loginClick = this.loginClick.bind(this);
  }

  componentWillMount() {
    // FUTURE: Move all this stuff to helpers/Database.js. Eventually that should be the only place that directly talks to firebase client.
    //this.firebaseApp = firebase.initializeApp(config);
    firebaseApp.auth().onAuthStateChanged((user) => {
      if (user && _.includes(ADMINS, user.uid)) {
        this.setState({signedIn: true, adminId: user.uid});
      } else {
        firebase.auth().signOut().then(() => {
          this.setState({signedIn: false, errorMessage: 'Permission denied.', adminId: null});
        }).catch((error) => {
          console.error(error.code + ": " + error.message);
          this.setState({signedIn: false, errorMessage: error.code + ": " + error.message, adminId: null});
        });
      }
    });
  }

  emailChange(e) {
    this.setState({email: e.target.value});
  }

  passwordChange(e) {
    this.setState({password: e.target.value});
  }

  loginClick(e) {
    e.preventDefault();
    this.setState({errorMessage: ''});

    firebaseApp.auth().signInWithEmailAndPassword(this.state.email, this.state.password)
      .catch((error) => {
      console.error(error.code + ": " + error.message);
      this.setState({signedIn: false, errorMessage: error.code + ": " + error.message});
    });
  }

  loggedOut() {
    this.setState({signedIn: false, adminId: null});
  }

  render() {
    let mainView = this.state.signedIn ?
      (<Main firebase={firebaseApp} adminId={this.state.adminId} loggedOut={this.loggedOut.bind(this)}></Main>) :
      (<form>
        <div style={{marginBottom:"10px"}}>Food Logging Admin Tool</div>
        <div>
          <label><b>Email</b></label>
          <input type="email" placeholder="Email" name="email" onChange={this.emailChange}/>
        </div>
        <div>
          <label><b>Password</b></label>
          <input type="password" name="password" onChange={this.passwordChange}/>
        </div>
        <div style={{marginBottom:"10px"}}>
          <button onClick={this.loginClick}>Login</button>
        </div>
        <div>
          <a href="https://platform.fatsecret.com">
              <img alt="Nutrition information provided by fatsecret Platform API" src="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_white.png" srcset="https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_white@2x.png 2x, https://platform.fatsecret.com/api/static/images/powered_by_fatsecret_horizontal_white@3x.png 3x" border="0"/>
          </a>
        </div>
      </form>);

    return (
      <div>
        {mainView}
        <div style={{color:'red'}}>{this.state.errorMessage}</div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/main/Signin.js